import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/btn_close-r.svg'


const _withScopeId = n => (_pushScopeId("data-v-dec6af16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-overflow-scroll jr-h-full" }
const _hoisted_2 = { class: "jr-flex jr-justify-end jr-overflow-scroll jr-bg-white" }
const _hoisted_3 = { class: "jr-bg-white jr-w-full jr-p-5 jr-pt-3 jr-rounded" }
const _hoisted_4 = {
  key: 0,
  class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-4.5 jr-mb-5"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-gray-dark jr-text-s-1" }, "時間帯", -1))
const _hoisted_6 = {
  key: 1,
  class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-4.5 jr-mb-5"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-s-2 jr-text-gray-dark jr-mb-2.5" }, "平日・土日祝別", -1))
const _hoisted_8 = { class: "jr-flex jr-justify-start jr-w-full jr-mt-4" }
const _hoisted_9 = {
  key: 2,
  class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-4.5 jr-mb-5"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-s-2 jr-text-gray-dark jr-mb-2.5" }, "駅までの交通手段別", -1))
const _hoisted_11 = { class: "jr-flex jr-mt-4" }
const _hoisted_12 = {
  key: 3,
  class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-4.5 jr-mb-5"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-s-2 jr-text-gray-dark jr-mb-2.5" }, "居住地・勤務地別", -1))
const _hoisted_14 = { class: "jr-flex jr-mt-4" }
const _hoisted_15 = { class: "jr-absolute jr-bg-gray-soft jr-left-0 jr-bottom-0 jr-py-4.5 jr-w-full jr-border-t jr-border-gray-medium" }
const _hoisted_16 = { class: "jr-pl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIHourRangePicker = _resolveComponent("UIHourRangePicker")!
  const _component_UICheckbox = _resolveComponent("UICheckbox")!

  return (_openBlock(), _createElementBlock("div", {
    "data-html2canvas-ignore": "true",
    class: "transition-width railway-filter jr-fixed jr-bottom-0 jr-right-0 jr-bg-gray-soft jr-pt-5 jr-pl-5 jr-pr-5 jr-z-30 jr-shadow-md",
    style: _normalizeStyle({ width: _ctx.minimum ? '64px' : '292px' })
  }, [
    _createElementVNode("figure", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isComparison)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_UIHourRangePicker, {
                  modelValue: _ctx.selectedTimeRange,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTimeRange) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isComparison || _ctx.isAnimation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_UICheckbox, {
                  icon: _ctx.isAllDaySelected ? 'tick' : 'minus',
                  label: "全て選択",
                  modelValue: _ctx.isAllDays,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAllDays) = $event)),
                  onChange: _ctx.handleAllDaysChange
                }, null, 8, ["icon", "modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.week, (w, index) => {
                    return (_openBlock(), _createBlock(_component_UICheckbox, {
                      key: w.name,
                      class: _normalizeClass({ 'jr-mr-8': index < _ctx.week.length - 1 }),
                      label: w.name,
                      modelValue: w.isSelected,
                      "onUpdate:modelValue": ($event: any) => ((w.isSelected) = $event),
                      onChange: _ctx.handleWeekChange
                    }, null, 8, ["class", "label", "modelValue", "onUpdate:modelValue", "onChange"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isHeatmap)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_UICheckbox, {
                  icon: _ctx.isAllTransportationSelected ? 'tick' : 'minus',
                  label: "全て選択",
                  modelValue: _ctx.isAllTransportation,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAllTransportation) = $event)),
                  onChange: _ctx.handleAllTransportationChange
                }, null, 8, ["icon", "modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transportations, (transportation, index) => {
                    return (_openBlock(), _createBlock(_component_UICheckbox, {
                      key: transportation.name,
                      class: _normalizeClass({ 'jr-mr-5': index < _ctx.transportations.length - 1 }),
                      label: transportation.name,
                      modelValue: transportation.isSelected,
                      "onUpdate:modelValue": ($event: any) => ((transportation.isSelected) = $event),
                      onChange: _ctx.handleTransportationChange
                    }, null, 8, ["class", "label", "modelValue", "onUpdate:modelValue", "onChange"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isHeatmap)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_UICheckbox, {
                  icon: _ctx.isAllResidentSelected ? 'tick' : 'minus',
                  label: "全て選択",
                  modelValue: _ctx.isAllResident,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isAllResident) = $event)),
                  onChange: _ctx.handleAllResidentChange
                }, null, 8, ["icon", "modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.residents, (resident, index) => {
                    return (_openBlock(), _createBlock(_component_UICheckbox, {
                      key: resident.name,
                      class: _normalizeClass({ 'jr-mr-5': index < _ctx.residents.length - 1 }),
                      label: resident.name,
                      modelValue: resident.isSelected,
                      "onUpdate:modelValue": ($event: any) => ((resident.isSelected) = $event),
                      onChange: _ctx.handleResidentChange
                    }, null, 8, ["class", "label", "modelValue", "onUpdate:modelValue", "onChange"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 512), [
        [_vShow, !_ctx.minimum]
      ]),
      _withDirectives(_createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args))),
        class: "jr-py-2.5 jr-mt-6.252 jr-bg-primary jr-shadow jr-w-full jr-text-sm jr-text-white jr-font-bold jr-rounded"
      }, "適用", 512), [
        [_vShow, !_ctx.minimum]
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickClose && _ctx.clickClose(...args)))
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "transition",
            style: _normalizeStyle({ transform: (_ctx.minimum ? 'rotate(180deg)' : 'rotate(0deg)') }),
            alt: "btn_close"
          }, null, 4)
        ])
      ])
    ])
  ], 4))
}